// useAuth.js
import { useState } from 'react';
import { http } from "../lib/axios";

const BASE_URL = '';

export const useAuth = () => {
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('user_role');
    return token ? { token, role } : null;
  });

  const loginUser = async (username, password, onRoleResolved) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', username);
    params.append('password', password);
    params.append('client_id', '2hbXY6q9DQ9xsy6afajvGouDu1RfVGRAPLl7oDuZ');
    params.append('client_secret', 'mysecret123');

    const { data } = await http.post(`${BASE_URL}/o/token/`, params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    const accessToken = data.access_token;
    const refresh = data.refresh_token;
    const access_expires_at = Date.now() + Number(data.expires_in) * 1000;

    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refresh);
    localStorage.setItem('access_expires_at', String(access_expires_at));

    const profileResponse = await http.get(`${BASE_URL}/api/accounts/me/`);

    const role = profileResponse.data.role;
    localStorage.setItem('user_role', role);
    setAuth({ token: accessToken, role });

    if (onRoleResolved && typeof onRoleResolved === 'function') {
      onRoleResolved(role);
    }
  };

  const logoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_role');
    setAuth(null);
  };

  return { auth, loginUser, logoutUser };
};
